import { render, staticRenderFns } from "./Science-ficationmodify.vue?vue&type=template&id=1aa60d18&scoped=true&"
import script from "./Science-ficationmodify.vue?vue&type=script&lang=js&"
export * from "./Science-ficationmodify.vue?vue&type=script&lang=js&"
import style0 from "./Science-ficationmodify.vue?vue&type=style&index=0&id=1aa60d18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa60d18",
  null
  
)

export default component.exports